module.exports = __webpack_public_path__ + "img/SKMJ_heavy9.6d809753.jpg";